// Mock data for Mental Health & Wellbeing Coach + Mobile Massage Website

export const businessInfo = {
  name: "Jena Schirmer",
  tagline: "Mental Health & Wellbeing Coach | Mobile Massage Therapist",
  email: "jaz.and.u.art@gmail.com",
  phone: "+49 157 3877 3842",
  location: "Munich, Germany",
  serviceArea: "Munich (In-person) | Worldwide (Online Coaching)"
};

export const heroContent = {
  title: "Your Journey to Wellness Begins Here",
  subtitle: "Professional Mental Health Coaching & Therapeutic Massage Services",
  description: "Supporting adults, couples, and teens through depression, PTSD, ADHD, and life's challenges with compassionate coaching and healing touch.",
  ctaText: "Book Your Session",
  image: "https://images.unsplash.com/photo-1618688259579-54fc3b432a3b"
};

export const aboutContent = {
  title: "About Jena",
  subtitle: "Dedicated to Your Wellbeing",
  bio: "With specialized training in mental health coaching and therapeutic massage, I provide a holistic approach to wellness. Whether you're navigating depression, PTSD, ADHD, or seeking overall wellbeing, I offer personalized support tailored to your unique journey.",
  credentials: [
    "Certified Mental Health & Wellbeing Coach",
    "Licensed Massage Therapist",
    "Specialization in Trauma-Informed Care",
    "ADHD & Depression Support Specialist"
  ],
  languages: ["English", "German"],
  image: "https://images.unsplash.com/photo-1616849068479-376693e487d2"
};

export const services = [
  {
    id: 1,
    title: "Mental Health Coaching",
    icon: "Brain",
    image: "https://images.unsplash.com/photo-1598901986949-f593ff2a31a6",
    shortDescription: "Personalized coaching for mental wellbeing and life challenges",
    fullDescription: "One-on-one coaching sessions designed to support your mental health journey. Specializing in depression, PTSD, ADHD, and general wellbeing for adults, couples, and teens.",
    benefits: [
      "Personalized coping strategies",
      "Goal setting and accountability",
      "Emotional regulation techniques",
      "Life transition support"
    ],
    deliveryMethods: ["Online Sessions (Worldwide)", "In-Person (Munich)"],
    duration: "60-90 minutes per session",
    pricing: "Available upon consultation"
  },
  {
    id: 2,
    title: "Therapeutic Massage",
    icon: "Heart",
    image: "https://images.pexels.com/photos/6628697/pexels-photo-6628697.jpeg",
    shortDescription: "Mobile massage therapy for physical and emotional relaxation",
    fullDescription: "Professional massage therapy services delivered to your location in Munich. Combining therapeutic techniques to release tension, reduce stress, and promote overall wellness.",
    benefits: [
      "Stress and tension relief",
      "Improved circulation",
      "Pain management",
      "Mind-body connection"
    ],
    deliveryMethods: ["Mobile Service (Munich area)", "In-Person Sessions"],
    duration: "60-90 minutes per session",
    pricing: "Available upon consultation"
  },
  {
    id: 3,
    title: "Workshops & Training",
    icon: "Users",
    image: "https://images.unsplash.com/photo-1618688259579-54fc3b432a3b",
    shortDescription: "Group sessions and educational workshops on wellness topics",
    fullDescription: "Interactive workshops and training sessions on mental health awareness, stress management, and wellbeing practices for organizations and groups.",
    benefits: [
      "Mental health awareness",
      "Stress management techniques",
      "Team wellbeing practices",
      "Self-care strategies"
    ],
    deliveryMethods: ["Online", "In-Person (Munich)", "Corporate Settings"],
    duration: "2-4 hours per workshop",
    pricing: "Custom pricing for groups"
  }
];

export const specialties = [
  {
    title: "Depression Support",
    description: "Compassionate guidance through difficult times"
  },
  {
    title: "PTSD & Trauma",
    description: "Trauma-informed care and healing approaches"
  },
  {
    title: "ADHD Management",
    description: "Strategies for focus and daily life management"
  },
  {
    title: "Couples Coaching",
    description: "Strengthening relationships and communication"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    feedback: "Jena's coaching helped me navigate through one of the darkest periods of my life. Her compassionate approach made all the difference.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael K.",
    feedback: "The combination of mental health coaching and massage therapy provided a holistic healing experience I didn't know I needed.",
    rating: 5
  },
  {
    id: 3,
    name: "Lisa & Tom",
    feedback: "As a couple, Jena helped us understand each other better and develop healthier communication patterns.",
    rating: 5
  }
];

export const faqData = [
  {
    question: "What types of issues do you help with?",
    answer: "I specialize in supporting individuals dealing with depression, PTSD, ADHD, anxiety, life transitions, relationship challenges, and general wellbeing concerns. I work with adults, couples, and teens."
  },
  {
    question: "Are sessions available online?",
    answer: "Yes! Coaching sessions are available online worldwide via secure video conferencing. Massage therapy is offered as a mobile service in the Munich area."
  },
  {
    question: "How long is a typical session?",
    answer: "Sessions typically range from 60-90 minutes, depending on your needs and the type of service. We'll discuss the best duration during our initial consultation."
  },
  {
    question: "Do you offer a free consultation?",
    answer: "Yes, I offer a brief initial consultation to discuss your needs and determine if my services are the right fit for you."
  },
  {
    question: "What languages do you speak?",
    answer: "I provide services in both English and German, ensuring you can communicate comfortably in your preferred language."
  }
];

export const resources = [
  {
    title: "HelpGuide.org",
    description: "Trusted guide to mental health and wellness",
    url: "https://www.helpguide.org/"
  },
  {
    title: "The Good Alliance",
    description: "Community support and resources",
    url: "https://thegoodalliance.org"
  }
];

export const appointmentTypes = [
  { value: "coaching-online", label: "Mental Health Coaching (Online)" },
  { value: "coaching-person", label: "Mental Health Coaching (In-Person, Munich)" },
  { value: "massage", label: "Therapeutic Massage (Mobile, Munich)" },
  { value: "workshop", label: "Workshop/Training Inquiry" },
  { value: "consultation", label: "Free Initial Consultation" }
];

// Mock function to simulate form submission
export const submitAppointmentRequest = async (formData) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  // Store in localStorage for demo purposes
  const existingRequests = JSON.parse(localStorage.getItem('appointmentRequests') || '[]');
  const newRequest = {
    ...formData,
    id: Date.now(),
    status: 'pending',
    submittedAt: new Date().toISOString()
  };
  existingRequests.push(newRequest);
  localStorage.setItem('appointmentRequests', JSON.stringify(existingRequests));
  
  return { success: true, data: newRequest };
};

export const submitContactForm = async (formData) => {
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  const existingMessages = JSON.parse(localStorage.getItem('contactMessages') || '[]');
  const newMessage = {
    ...formData,
    id: Date.now(),
    submittedAt: new Date().toISOString()
  };
  existingMessages.push(newMessage);
  localStorage.setItem('contactMessages', JSON.stringify(existingMessages));
  
  return { success: true, data: newMessage };
};
